//全局组件

import SvgIcon from './svg-icon'

export default {
	SvgIcon
}
